export default {
  notify: {
    en: 'Notify when available',
  },
  subscribed: {
    en: `We'll notify you`,
  },
}
